export const selectTransformation = state => state.transformation.transformations
export const selectProductWIthDerivedProducts = state =>
  state.transformation.productWIthDerivedProducts
export const selectInventoryList = state => state.transformation.inventoryList
